import { createSelector } from 'reselect'
import config from 'constants/config'
import { Experiments } from 'constants/experiments'
import { getExperimentEnabledDecision, getOptimizelyExperimentVariation } from 'lib/optimizely/optimizelyUtils'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { isSpoofed } from 'selectors/isSpoofed'
export const getCanActivateMobileAppLikeCheckout = createSelector(
  (state: App.State) => state.system?.device?.deviceType === 'mobile',
  (state: App.State) => findPostPurchaseCheckout(state.checkout?.cart?.mode),
  (state: App.State) => isSpoofed(state),
  (isMobileDevice, postPurchaseMode, isSpoofed): boolean => {
    return config.BRAND === 'luxuryescapes' && isMobileDevice && !postPurchaseMode && !isSpoofed
  },
)

export const getIsMobileAppLikeCheckoutEnabled = createSelector(
  (state: App.State) => getCanActivateMobileAppLikeCheckout(state),
  (state: App.State) => getOptimizelyExperimentVariation(state, Experiments.croMobileWebAppLikeCheckout.id),
  (canActivate, variation): boolean => canActivate && getExperimentEnabledDecision(variation),
)
